import React from 'react';
import { Modal } from '../Modal';
import { useNavbarContext } from './NavbarContext';
export function NavbarModal(props) {
    const { children, insetBlockStart, ...rest } = props;
    const { height } = useNavbarContext();
    return (React.createElement(Modal, { ...rest, dialog: true, disableScrollLock: true, className: "mollie-ui-navbar-modal", UNSAFE_wrapperClassName: "mollie-ui-navbar-modal-wrapper", insetBlockStart: insetBlockStart !== null && insetBlockStart !== void 0 ? insetBlockStart : height }, children));
}
NavbarModal.displayName = 'Navbar.Modal';
//# sourceMappingURL=NavbarModal.js.map